module.exports = __webpack_public_path__ + "img/button-mnemonic-hover.00b55ce1.svg";